import React, { useState, useEffect } from "react";
import styles from "../../styles/screens/AmritjalBooking/AmritjalCheckoutPage.module.css";
// import amritjalImage from "../../assets/amritjal_hp/classFragrance.png";
// import roseJalImage from "../../assets/amritjal_hp/roseFragrance.png"
// import vrindavanPrasadBoxImage from "../../assets/holiprasad/prasadBox.png";
import getDharmikxOrderId from "../../utils/dharmikxOrder";
import {
  doc,
  getDoc,
  updateDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import CreateDharmikxOrderFDB from "../../components/Payment/CreateDharmikxOrderFDB";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import {initiate, verify} from "../../utils/otpless";
import { db } from "../../utils/firestoredb";
import {Oval} from 'react-loader-spinner';
import { usePostHog } from "posthog-js/react";
import WhatsAppSupport from "../../components/Support/WhatsAppSupport";
import generateReferralCode from "../../utils/Referral";
import Metadata from "../../components/metadata/MetaData";
import NavBar from "../../components/Navbar";

const AmritjalCheckoutPage = () => {
  const {productId} = useParams();
  const [step, setStep] = useState(1);
  const [quantity, setQuantity] = useState(1);
   const timeLeftKey = "timeLeft" + productId;
    const [timeLeft, setTimeLeft] = useState(() => {
          const storedTime = sessionStorage.getItem(timeLeftKey);
          return storedTime ? parseInt(storedTime, 10) : 0;
        });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(300);
  const [couponCode, setCouponCode] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [productDetails, setProductDetails] = useState(null);
  const [originalProductPrice, setOriginalProductPrice] = useState("");
  const [finalProductPrice, setFinalProductPrice] = useState("");
  const [finalOrderId, setFinalOrderId] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [isCouponValid, setIsCouponValid] = React.useState(false);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    phoneNo:"",
    pincode: "",
  });
  const [isOrderSummaryVisible, setIsOrderSummaryVisible] = useState(false);
  const [showCoupons, setShowCoupons] = useState(false);
  const [actualOriginalPrice, setActualOriginalPrice] = useState("");
  const [errors, setErrors] = useState({});
  const [isGeneratingOrderId, setIsGeneratingOrderId] = useState(false);
  const [isOfferExpired, setIsOfferExpired] = useState(false);
  const [productImage, setProductImage] = useState("");
  const posthog = usePostHog();

  // Static JSON data for coupons
  const coupons = [
    {
      code: "FIRSTORDER",
      description: "5% off on your first order",
      percentage: "5",
      max : "",
      mintransaction : "0",
    },
    {
      code: "SAVE20",
      description: "20% off on orders above Rs.1000",
      percentage: "20",
      max : "",
      mintransaction : "1000",
    },
  ];

  const convertTimeLeft = (seconds) => {
    const minutesLeft = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return { minutesLeft, secondsLeft };
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  useEffect(() => {
    const fetchProductDetails = async () => {
      const amritJalSprayDocRef = doc(db, "dharmikxproducts", productId);
      const amritJalSprayDocSnap = await getDoc(amritJalSprayDocRef);

      if (amritJalSprayDocSnap.exists()) {
        const productData = amritJalSprayDocSnap.data();
        setProductDetails(productData);
        setActualOriginalPrice(productData.price.original);
        setOriginalProductPrice(productData.price.discounted);
        setFinalProductPrice(productData.price.discounted);
        setProductImage(productData.banner_image);
      } else {
        console.log("Error Fetching Puja Details for Amritjal spray: ");
      }
    };

    fetchProductDetails();
  }, [productId]);

  useEffect(() => {
      if (timeLeft > 0) {
        const timer = setInterval(() => {
                  setTimeLeft((prevTime) => {
                    const updatedTime = Math.max(prevTime - 1, 0);
                    sessionStorage.setItem(timeLeftKey, updatedTime);
                    return updatedTime;
                  });
        }, 1000);
  
        return () => clearInterval(timer);
      } else {
        setIsOfferExpired(true);
        setOriginalProductPrice(actualOriginalPrice);
        setDiscountAmount(0);
        sessionStorage.removeItem(timeLeftKey);
      }
    }, [timeLeft,timeLeftKey, actualOriginalPrice]);

    useEffect(() => {
        posthog.capture("$pageview");
      }, [posthog]);

  useEffect(() => {
      console.log('INPUT VALUE CHANGED TO - ', couponCode);
    }, [couponCode]);

  useEffect(() => {
      if (step === 2) {
        fetchAddressesByPhone(phoneNumber).then((fetchedAddresses) => {
          if (fetchedAddresses.length > 0) {
            setSavedAddresses(fetchedAddresses);
          } else {
            setShowForm(true); // Show the form if no addresses are found
          }
        });
      }
    }, [step, phoneNumber]);

  useEffect(() => {
    const finalPrice = (parseInt(originalProductPrice) * quantity).toString();
    setFinalProductPrice(finalPrice);
    const updateOrderId = async () => {
      setIsGeneratingOrderId(true);
      const orderId = await getDharmikxOrderId(finalPrice, "INR");
      if(orderId) {
        setFinalOrderId(orderId);
      }
      setIsGeneratingOrderId(false);
    }

    updateOrderId();
  }, [quantity, originalProductPrice]);

  useEffect (() => {
    const updateOriginalOrderId = async () => {
      const finalprice = (parseInt(originalProductPrice) * quantity).toString();
      if(!isCouponValid) {
        const orgOrderId = await getDharmikxOrderId(finalprice, "INR");
        if(orgOrderId) {
          setFinalOrderId(orgOrderId);
        }
      }
    };
    updateOriginalOrderId();
  },[quantity, originalProductPrice, isCouponValid])

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };
  
  const validateOtp = async (otp) => {

    if (!otp.every((digit) => digit !== "")) {
      alert("Please enter all 6 digits of the OTP.");
      return false;
    }

    try {
      const otpString = otp.join(""); // Convert array to string
      console.log(otpString);
 
      const response = await verify(phone, otpString);
      console.log(response);
      
      if (response === true) {
        setStep(2);
        localStorage.setItem("phoneNumber", JSON.stringify(phoneNumber));
        const userRef = doc(db, "users", phoneNumber);
        const userSnapshot = await getDoc(userRef);
        
        posthog.identify(phoneNumber, {
          phone : phoneNumber,
          platform : "web",
          category : "web_user",
        });
  
        posthog.people.set({
          phone : phoneNumber,
          platform : "web",
          category : "web_user",
        });
  
        if (userSnapshot.exists()) {
          await updateDoc(userRef, {
            phoneNumber: phoneNumber,
          });
        } else {
          await setDoc(userRef, {
            phoneNumber: phoneNumber,
            platform: "web",
            category: "general",
            referral_code: generateReferralCode(phoneNumber),
            time: serverTimestamp(),
            last_login: serverTimestamp(),
          });
          const referralRef = doc(
            db,
            "referral_db",
            generateReferralCode(phoneNumber)
          );
          await setDoc(referralRef, {
            count: 0,
          });
  
          posthog.capture('user_signed_up', {
            phone: phoneNumber,
            platform: "web",
            category: "web_user",
          });
        }

        posthog.capture('user_logged_in', {
          phone: phoneNumber,
          platform: "web",
          category: "web_user",
        });

        return true;
      }
    } catch (error) {
      console.error("OTPLESS Verify Error:", error);
      //alert("OTP verification failed. Please try again.");
      toast.error("OTP verification failed. Please try again.", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
      posthog.capture('login_error', {
        error_message: error.message,
        phone: phoneNumber
      });
      return false;
    }
  };
  
  const validateAddress = (address) => {

    const newErrors = {};
      // Name validation
      if (!address.name || address.name.length < 3 || !/^[a-zA-Z\s]+$/.test(address.name)) {
        newErrors.name = "Name should contain only letters.";
      }
  
      // Street validation
      if (!address.street || address.street.trim() === "") {
        newErrors.street = "Address cannot be empty.";
      }
  
      // Pincode validation
      if (!address.pincode || !/^\d{6}$/.test(address.pincode)) {
        newErrors.pincode = "Pincode must be exactly 6 digits.";
      }
  
      // City validation
      if (!address.city || !/^[a-zA-Z\s]+$/.test(address.city)) {
        newErrors.city = "City should contain only letters.";
      }
  
      // State validation
      if (!address.state || address.state.trim() === "") {
        newErrors.state = "State is required.";
      }
  
      // Email validation
      if (!address.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address.email)) {
        newErrors.email = "Please enter a valid email address.";
      }
  
      setErrors(newErrors);
  
      return Object.keys(newErrors).length === 0;
  };

  const fetchAddressesByPhone = async (phoneNumber) => {
    try {
      // Reference to the document in the "saved_address" collection
      const savedAddressRef = doc(db, "saved_address", phoneNumber);
  
      // Fetch the document data
      const querySnapshot = await getDoc(savedAddressRef);
  
      // Process and return the data
      return querySnapshot.data() ? Object.values(querySnapshot.data()) : [];
    } catch (error) {
      console.error("Error fetching addresses:", error);
      return [];
    }
  };

  const applyCoupon = async (coupon) => {
    setCouponCode(coupon.code);
    setIsApplyingCoupon(true);
    const finalprice = (parseInt(originalProductPrice)*quantity).toString();
    if(coupon.code !== "" && parseInt(finalprice) >= parseInt(coupon.mintransaction)){

      const percent = coupon.percentage;
      const max = coupon.max;
  
      let discountAmt = 0;
  
      // Check if percentage is specified
      if (percent !== '') {
        discountAmt = (parseInt(finalprice) * parseInt(percent)) / 100;
      }
  
      // Check if max discount is specified
      if (max !== '') {
        const maxDiscount = parseInt(max);
        if (percent === '') {
          discountAmt = maxDiscount;
        } else {
          discountAmt = Math.min(discountAmt, maxDiscount);
        }
      }

      discountAmt = Math.min(discountAmt, parseInt(finalprice));
      setDiscountAmount(discountAmt);
      console.log('DISCOUNT AMOUNT FINALLY : ', discountAmount);
  
      // Update the final puja price
      var updatedProductPrice= (parseInt(finalprice) - discountAmt).toString();
      setFinalProductPrice(updatedProductPrice);
      console.log('FINAL PRODUCT PRICE AFTER DISCOUNT - ', finalprice);
      console.log("LATEST UPATED FINAL PRICE : ", finalprice);

      const orderId = await getDharmikxOrderId(updatedProductPrice, "INR");
      
      if(orderId) {
        setFinalOrderId(orderId);
      }
      setIsCouponValid(true);
    } else {
      setIsCouponValid(false);
      setDiscountAmount(0);
      toast.error('Invalid Coupon Code', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
    setIsApplyingCoupon(false);
  };

  const handleInputChange = (event) => {
    setCouponCode(event.target.value.toString());
    setIsCouponValid(false);
    setDiscountAmount(0);
    //console.log(originalProductOrderId);
    const finalprice = (parseInt(originalProductPrice)*quantity).toString();
    setFinalProductPrice(finalprice);
  };

  const validateCouponCode = async () => {
    setIsApplyingCoupon(true);
    if(couponCode === ''){
      toast.error('Coupon Code is empty', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    } else {
    // validate coupon code from the firestore and reset the finalPuajPrice
    const finalprice = (parseInt(originalProductPrice)*quantity).toString();
    const couponCodeRef =  doc(db, "dharmikxcoupons", couponCode);
    const couponCodeDoc = await getDoc(couponCodeRef);
  
    if(couponCodeDoc.exists()) {
      const couponData = couponCodeDoc.data();
      console.log('COUPON DATA : ', couponData);
      console.log("MIN TRAN : ", couponData.discount.mintransaction);
      if(parseInt(finalprice) < parseInt(couponData.discount.mintransaction)) {
        toast.error('Invalid coupon code. The minimum transaction value must be Rs. 1000.', {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
        });
      }else {
        const percent = couponData.discount.percentage;
        const max = couponData.discount.max;
    
        let discountAmt = 0;
    
        // Check if percentage is specified
        if (percent !== '') {
          discountAmt = (parseInt(finalprice) * parseInt(percent)) / 100;
        }
    
        // Check if max discount is specified
        if (max !== '') {
          const maxDiscount = parseInt(max);
          if (percent === '') {
            discountAmt = maxDiscount;
          } else {
            discountAmt = Math.min(discountAmt, maxDiscount);
          }
        }
    
        // Ensure discount amount does not exceed original puja price
        discountAmt = Math.min(discountAmt, parseInt(finalprice));
        console.log('DISCOUNT AMOUNT : ', discountAmt);
        setDiscountAmount(discountAmt);
        console.log('DISCOUNT AMOUNT FINALLY : ', discountAmount);
    
        // Update the final puja price
        var updatedProductPrice= (parseInt(finalprice) - discountAmt).toString();
        setFinalProductPrice(updatedProductPrice);
        console.log('FINAL PRODUCT PRICE AFTER DISCOUNT - ', finalprice);

        const orderId = await getDharmikxOrderId(updatedProductPrice, "INR");
        
        if(orderId) {
          setFinalOrderId(orderId);
        }
        setIsCouponValid(true);
      }
    } else {
      setIsCouponValid(false);
      setDiscountAmount(0);
      toast.error('Invalid Coupon Code', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "light",
      });
    }
    }
    setIsApplyingCoupon(false);
  };

  const validatePhone = async (phone) => {
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return false;
    }
    await initiate(phone);
    return true;
  };

  const handleOtpChange = (index, value) => {
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  if(!productDetails) {
    return(
      <Oval 
        color="#ff8e4d"
        height="20%"
        width="20%"
        strokeWidth={4}
        ariaLabel="Loading"
        wrapperStyle={{position: "fixed", top: "45%", left: "45%"}}
        wrapperClass="loader"
      />
  );
  }

  const { minutesLeft, secondsLeft } = convertTimeLeft(timeLeft);

  return (
    <>
      <NavBar/>
      <ToastContainer/>
      <WhatsAppSupport/>
      <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />

      {/* Mobile Timer */}
      {!isOfferExpired ? (
        <div className={styles.mobileTimerContainer}>
        <div className={styles.timer}>
          <span className={styles.timer__text}>We are holding your price .... </span>
          <div className={styles.timer__digits}>
            <span className={styles.timer__number}>{String(minutesLeft).padStart(2, "0")}</span>
            <span>:</span>
            <span className={styles.timer__number}>{String(secondsLeft).padStart(2, "0")}</span>
          </div>
        </div>
      </div>
      ) : null
    }

      {/* Mobile Order Summary Dropdown */}
      <div className={styles.mobileOrderSummary}>
        <button
          className={styles.summaryToggle}
          onClick={() => setIsOrderSummaryVisible(!isOrderSummaryVisible)}
        >
          <span>Click here to view order summary</span>
          <span>{isOrderSummaryVisible ? "^" : "⌄"}</span>
        </button>
        {isOrderSummaryVisible && (
          <div className={styles.mobileSummaryContent}>
            <div className={styles.productCard}>
              <img
                src={productImage}
                alt="Amrit Jal Spray"
                className={styles.productImage}
              />
              <div className={styles.productDetails}>
                <h2 className={styles.productTitle}>
                  {productDetails.title}
                </h2>
                <p>Price: Rs.{originalProductPrice}</p>
                <div className={styles.quantityControls}>
                  <button
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                    className={styles.quantityControlBtn}
                  >
                    -
                  </button>
                  <span>{quantity}</span>
                  <button
                    onClick={() => setQuantity((q) => q + 1)}
                    className={styles.quantityControlBtn}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.priceBreakdown}>
              <div className={styles.priceRow}>
                <span>Subtotal</span>
                <span>Rs.{actualOriginalPrice * quantity}</span>
              </div>
              <div className={styles.priceRow}>
                <span>Limited Time Discount</span>
                <span>Rs.{((actualOriginalPrice - originalProductPrice) * quantity)}</span>
              </div>
              <div className={`${styles.priceRow} ${styles.coupon}`}>
                <span>{isCouponValid ? "Coupon Applied" : "Coupon"}</span>
                <span>{isCouponValid ? couponCode : ""}</span>
              </div>
              {isCouponValid ? (
              <div style={{display:"flex",justifyContent:"end"}}>
              <span>You have saved Rs. {Math.round(parseFloat(discountAmount)).toString()}</span>
              </div>
            ) : null
          }
              <div className={`${styles.priceRow} ${styles.total}`}>
                <span>Total</span>
                <span>Rs.{Math.round(parseFloat(finalProductPrice)).toString()}</span>
              </div>
            </div>

            <div className={styles.couponSection}>
              <input
                type="text"
                placeholder="Coupon Code"
                value={couponCode}
                onChange={handleInputChange}
              />
              <button onClick={validateCouponCode}>
                {isApplyingCoupon ? 'wait..' : (isCouponValid ? 'Applied' : 'Apply')}
              </button>
            </div>
           <>
           {!showCoupons ? (
             <p
               className={styles.viewCoupons}
               onClick={() => setShowCoupons(true)}
             >
               View Available Coupons
             </p>
           ) : (
             <>
               <p
                 className={styles.viewCoupons}
                 onClick={() => setShowCoupons(false)}
               >
                 Hide Available Coupons
               </p>
               <div className={styles.couponList}>
                 {coupons.map((coupon, index) => (
                   <div
                     key={index}
                     className={styles.couponCard}
                     onClick={() =>{ 
                      applyCoupon(coupon)
                      setShowCoupons(false)
                     }}
                   >
                     <h3>{coupon.code}</h3>
                     <p>{coupon.description}</p>
                   </div>
                 ))}
               </div>
             </>
           )}
         </>
          </div>
        )}
      </div>

      <div className={styles.checkoutContainer}>
        {/* Left Section - Desktop */}
        <div className={styles.leftSection}>
          <div className={styles.productCard}>
            <img
              src={productImage}
              alt="Amrit Jal Spray"
              className={styles.productImage}
            />
            <div className={styles.productDetails}>
              <h2 className={styles.productTitle}>
                {productDetails.title}{quantity > 1 ? ` ( x${quantity})` : ""}
              </h2>
              <p>Price: Rs.{productDetails.price.original}</p>
              <div className={styles.quantityControls}>
                <button
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  className={styles.quantityControlBtn}
                >
                  -
                </button>
                <span>{quantity}</span>
                <button
                  onClick={() => setQuantity((q) => q + 1)}
                  className={styles.quantityControlBtn}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div className={styles.priceBreakdown}>
            <div className={styles.priceRow}>
              <span>Subtotal</span>
              <span>Rs.{actualOriginalPrice * quantity}</span>
            </div>
            <div className={styles.priceRow}>
              <span>Limited Time Discount</span>
              <span>Rs.{((actualOriginalPrice - originalProductPrice) * quantity)}</span>
            </div>
            <div className={`${styles.priceRow} ${styles.coupon}`}>
              <span>{isCouponValid ? "Coupon Applied" : "Coupon"}</span>
              <span>{isCouponValid ? couponCode : ""}</span>
            </div>
            {isCouponValid ? (
              <div style={{display:"flex",justifyContent:"end"}}>
              <span>You have saved Rs. {Math.round(parseFloat(discountAmount)).toString()}</span>
              </div>
            ) : null
          }
            <div className={`${styles.priceRow} ${styles.total}`}>
              <span>Total</span>
              <span>Rs.{Math.round(parseFloat(finalProductPrice)).toString()}</span>
            </div>
          </div>

          <div className={styles.couponSection}>
            <input
              type="text"
              placeholder="Coupon Code"
              value={couponCode}
              onChange={handleInputChange}
            />
            <button onClick={validateCouponCode}>{isApplyingCoupon ? 'wait ..' : (isCouponValid ? 'applied' : 'Apply Coupon')}</button>
            
          </div>
         
           <>
           {!showCoupons ? (
             <p
               className={styles.viewCoupons}
               onClick={() => setShowCoupons(true)}
             >
               View Available Coupons
             </p>
           ) : (
             <>
               <p
                 className={styles.viewCoupons}
                 onClick={() => setShowCoupons(false)}
               >
                 Hide Available Coupons
               </p>
               <div className={styles.couponList}>
                 {coupons.map((coupon, index) => (
                   <div
                     key={index}
                     className={styles.couponCard}
                     onClick={() =>{ 
                      applyCoupon(coupon)
                      setShowCoupons(false)
                     }}
                   >
                     <h3>{coupon.code}</h3>
                     <p>{coupon.description}</p>
                   </div>
                 ))}
               </div>
             </>
           )}
         </>
       
        </div>

        {/* Vertical Line */}
        <div className={styles.verticalLine}></div>

        {/* Right Section */}
        <div className={styles.rightSection}>
          {!isOfferExpired ? (
            <div className={styles.timer}>
            <span className={styles.timer__text}>We are holding your price .... </span>
            <div className={styles.timer__digits}>
              <span className={styles.timer__number}>{String(minutesLeft).padStart(2, "0")}</span>
              <span>:</span>
              <span className={styles.timer__number}>{String(secondsLeft).padStart(2, "0")}</span>
            </div>
          </div>
          ) : null
        }
          <div className={styles.progressSteps}>
            <div className={`${styles.step} ${step >= 1 ? styles.active : ""}`}>
              Contact
            </div>
            <div className={`${styles.step} ${step >= 2 ? styles.active : ""}`}>
              Address
            </div>
            <div className={`${styles.step} ${step >= 3 ? styles.active : ""}`}>
              Payment
            </div>
          </div>

          {step === 1 && (
  <div className={styles.verificationSection}>
    <div className={styles.otp_container}>
      <p className={styles.otp_title}>Verify Mobile Number</p>
      <p className={styles.otp_subtitle}>(OTP will be sent on WhatsApp)</p>
    </div>
    <div className={styles.contactInputGroup}>
      <span className={styles.contactPrefix}>+91</span>
      <input
        type="tel"
        className={styles.phoneInput}
        placeholder="Enter your mobile number"
        value={phone}
        onChange={(e) => {setPhone(e.target.value.replace(/[^0-9]/g, "")); setPhoneNumber("+91"+e.target.value)}}
        maxLength={10}
      />
    </div>
    <button
      className={styles.contactButton}
      onClick={() => {
        if (!phone || phone.length !== 10) {
          toast.error('Please enter a valid 10-digit mobile number', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          return;
        }
        validatePhone(phone) && setStep(1.5);
      }}
    >
      Send OTP
    </button>
  </div>
)}

{step === 1.5 && (
  <div className={styles.verificationSection}>
    <h2>Verify Phone Number</h2>
    <p>OTP sent to {phone}</p>
    <div className={styles.otpInputs}>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          name={`otp-${index}`}
          value={digit}
          onChange={(e) => handleOtpChange(index, e.target.value)}
          inputmode="numeric" 
          maxlength="6"
        />
      ))}
    </div>
    <button
      className={styles.continueBtn}
      onClick={async () => {
        if (!otp.every(digit => digit !== "")) {
          toast.error('Please enter complete OTP', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
          return;
        }

        try {
          const isValid = await validateOtp(otp);
          console.log("valid",isValid)
          if (isValid) {
            setStep(2);
            //const finalPrice = (parseInt(finalProductPrice)*quantity).toString();
            //CreateDharmikxOrderFDB(phoneNumber, productDetails.productId, finalOrderId, finalPrice, productDetails.description, productDetails.banner_image, quantity, isCouponValid ? couponCode : "");
          } else {
            toast.error('Invalid OTP. Please try again.', {
              position: "top-center",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              theme: "light",
            });
          }
        } catch (error) {
          toast.error('Error validating OTP. Please try again.', {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      }}
    >
      CONTINUE
    </button>
    <p className={styles.resend}>Resend OTP in {formatTime(timer)}</p>
  </div>
)}

{step === 2 && (
  <div className={styles.container}>
    <h2 className={styles.heading}>SHIPPING ADDRESS</h2>

    {/* Display Saved Addresses */}
    {savedAddresses.length > 0 && !showForm ? (
      <div className={styles.addressList}>
        {savedAddresses.map((savedAddress, index) => (
          <div
            key={index}
            className={styles.addressCard}
            onClick={() => {
              setAddress(savedAddress); // Fill the form with this address
              setShowForm(true); // Switch to the form view
            }}
          >
            <p>{savedAddress.addressName}</p>
            <p>{savedAddress.street}</p>
            <p>
              {savedAddress.locality}, {savedAddress.city} - {savedAddress.pincode}
            </p>
            <p>{savedAddress.email}</p>
            <div className={styles.cardIcons}>
              <span
                className={styles.editIcon}
                onClick={()=>
                  setShowForm(true)}
              >
                ✏️
              </span>
              {/* <span
                className={styles.deleteIcon}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering card click
                  handleDelete(savedAddress); // Handle delete address
                }}
              >
                🗑️
              </span> */}
            </div>
          </div>
        ))}
        <div className={styles.addAddressCard} onClick={() => setShowForm(true)}>
          Add a New Address
        </div>
      </div>
    ) : (
      showForm && (
        <div className={styles.formGroup}>
           <div className={styles.row}>
      <div>
        <input
          type="text"
          placeholder="Name"
          className={styles.input}
          value={address.name}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, name: e.target.value }))
          }
        />
        {errors.name && <p className={styles.error}>{errors.name}</p>}
      </div>
      <input
        type="text"
        value={address.phoneNo || phoneNumber}
        className={styles.input}
        readOnly
      />
    </div>

    <div>
      <textarea
        placeholder="Address"
        className={styles.textarea}
        value={address.street}
        onChange={(e) =>
          setAddress((prev) => ({ ...prev, street: e.target.value }))
        }
      ></textarea>
      {errors.street && <p className={styles.error}>{errors.street}</p>}
    </div>

    <div className={styles.rowThree}>
      <div>
        <input
          type="text"
          placeholder="Pincode"
          className={styles.input}
          value={address.pincode}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, pincode: e.target.value }))
          }
        />
        {errors.pincode && <p className={styles.error}>{errors.pincode}</p>}
      </div>
      <div>
        <input
          type="text"
          placeholder="City"
          className={styles.input}
          value={address.city}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, city: e.target.value }))
          }
        />
        {errors.city && <p className={styles.error}>{errors.city}</p>}
      </div>
      <div>
        <input
          type="text"
          placeholder="State"
          className={styles.input}
          value={address.state}
          onChange={(e) =>
            setAddress((prev) => ({ ...prev, state: e.target.value }))
          }
        />
        {errors.state && <p className={styles.error}>{errors.state}</p>}
      </div>
    </div>

    <div className={styles.rowEmail}>
      <input
        type="email"
        placeholder="Email"
        className={styles.input}
        value={address.email}
        onChange={(e) =>
          setAddress((prev) => ({ ...prev, email: e.target.value }))
        }
      />
      {errors.email && <p className={styles.error}>{errors.email}</p>}
    </div>
          <button
            className={styles.button}
            disabled={finalOrderId===null}
            onClick={() => {
              if (validateAddress(address)) {
                setStep(3);
                CreateDharmikxOrderFDB(
                  finalOrderId,
                  phoneNumber,
                  productDetails.productId,
                  originalProductPrice,
                  productDetails.description,
                  productDetails.banner_image,
                  quantity, 
                  isCouponValid ? couponCode : "",
                  address.name,
                  address.street,
                  address.pincode,
                  address.city,
                  address.state,
                  address.email,
                  quantity,
                  discountAmount
                );

                
              }
            }}
          >
          {(isApplyingCoupon === true || isGeneratingOrderId) ? "wait..." : "Pay"}
          </button>
        </div>
      )
    )}
  </div>
)}

        </div>
      </div>
    </>
  );
};

export default AmritjalCheckoutPage;
